export const isValidDate = (d) => {
  // @ts-ignore
  return d instanceof Date && !isNaN(d);
};
